import { useQueries } from '@tanstack/react-query';

import { searchUsers } from 'apis/restaurant-api/merchant-admin/user/api';

export function useFetchUsers(userIds: string[]) {
  const results = useQueries({
    queries: userIds.map(id => {
      return {
        queryKey: ['searchUsers', id],
        queryFn: () => searchUsers(id),
        enabled: !!userIds.length,
      };
    }),
  });

  const isLoading = results.some(query => query.isLoading);
  const errors = results.filter(query => !!query.error);
  const data = results.map(query => query.data?.users?.[0]).filter(Boolean);

  return {
    isLoading,
    errors: errors.length ? errors : null,
    data,
  };
}
